module.exports = __webpack_public_path__ + "img/s8sLogo7.5ec20727.png";